import React, { FC, useState } from 'react';
import TaskDetailsRailLeftLayout from '@ui-components/task-details-rail-left-layout';
import ScrollWithFadeLayout from '@ui-components/scroll-with-fade-layout';
import { IconType } from '@ui-components/icon-template';

import { Shelf } from '../../common/types';
import { TaskDetailsRailLeftNavigationItem } from '..';

interface Props {
  shelves: Shelf[];
  onRailItemClick: (shelfId: string) => void;
  selectedShelf: string;
  registeredShelves: {
    [key: string]: {
      icon: IconType;
      menuLabel: string;
      dynamicNavigationLabel: boolean;
    };
  };
}

const TaskDetailsRailLeft: FC<Props> = ({
  shelves,
  onRailItemClick,
  selectedShelf,
  registeredShelves
}) => {
  const [navigationVisible, setNavigationVisible] = useState(false);

  const handleClickNavigationBar = () => {
    setNavigationVisible(!navigationVisible);
  };

  const toggleIconName = (): IconType => (navigationVisible ? 'closeSkinny' : 'grilledCheese');

  const getNavigationItemLabel = (shelf: Shelf) => {
    if (
      registeredShelves[shelf.shelfType] &&
      registeredShelves[shelf.shelfType].dynamicNavigationLabel
    ) {
      return shelf.subtitle;
    }
    return null;
  };

  return (
    <TaskDetailsRailLeftLayout
      toggleComponent={
        <TaskDetailsRailLeftNavigationItem
          iconName={toggleIconName()}
          handleClick={handleClickNavigationBar}
          navigationVisible={navigationVisible}
          label=""
          width={navigationVisible ? 15 : 20}
          height={15}
          id="openClose"
          isToggleItem
        />
      }
    >
      <ScrollWithFadeLayout useFadeEffect={!navigationVisible} scrollOrientation="vertical">
        {shelves &&
          shelves.map(
            (shelf: Shelf) =>
              registeredShelves[shelf.shelfType] && (
                <TaskDetailsRailLeftNavigationItem
                  key={`TaskDetailsRailLeftNavigationItem${shelf.id}`}
                  iconName={registeredShelves[shelf.shelfType].icon}
                  handleClick={() => onRailItemClick(shelf.id)}
                  label={
                    getNavigationItemLabel(shelf) || registeredShelves[shelf.shelfType].menuLabel
                  }
                  navigationVisible={navigationVisible}
                  notificationCount={
                    shelf.collaborationSummary && shelf.collaborationSummary.unreadCount
                  }
                  id={shelf.id}
                  selected={selectedShelf === shelf.id}
                />
              )
          )}
      </ScrollWithFadeLayout>
    </TaskDetailsRailLeftLayout>
  );
};

export default TaskDetailsRailLeft;
